import React,{useState,useEffect} from "react";


import { useDispatch } from "react-redux";
const RangeSliderDynamic = ({setSliderVal,sliderVal,rangeIntervalType, rangeStart,rangeEnd ,pxPerType  }) => {
  
  
    
       const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
            
       
  
  const [value, setValue] = useState();
     useEffect(()=>{
      setValue(sliderVal?sliderVal:10)
     },[])
      let intervals=[1,100]
      intervals =[0,40,80,100,140,180,200];
    // if(rangeIntervalType=="layoutGap"){
    // intervals =[0,5,10,15,20,25,30];
    // }
    
    return (
      <div className="range-slider-basic">
        <input
          type="range"
          min={rangeStart}
          max={rangeEnd}
          value={value}
          onChange={(e) => {setValue(parseInt(e.target.value)) ;setSliderVal(parseInt(e.target.value))}}
          className="slider-basic"
        />
        <div className="marks"> 
        {intervals?.map((mark,index) => (
          <span  onClick={() => {setValue(mark) ;setSliderVal(mark);;}}  onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
            key={mark}
            className={`mark-basic ${value === mark ? '' : ''}`}
            style={{ left: `${index*115/intervals?.length}%` }}
          >
            {mark}
          </span>
        ))}
      </div>{/* Marker that moves with thumb */}
  <div
    className={`mark-floating ${value ? 'active-basic' : ''}`}
    style={{
      left: `${((value ) / (rangeEnd )) * 100}%`,
    }}
  >
    {value}{pxPerType}
  </div>
          </div>
    );
  };
  export default RangeSliderDynamic;